<div class="tap-top" (click)="tapToTop()" (keydown.enter)="tapToTop()" [ngStyle]="{ display: show ? 'block' : 'none' }">
  <app-feather-icons [icons]="'chevrons-up'"></app-feather-icons>
</div>
